export default class General {
    constructor() {
        this.initMobileMenu();
        this.initMobileOverlay();
        this.initBackgroundImages();
        this.initLanguageDropdown();
        this.initAutoPlayVideos();
        this.initMoveCouponToSidebar();
        this.initCheckoutNotices();
        this.initMobileOrderSummary();
    }

    initMobileOverlay() {
        const mobileUtilityContainer = document.querySelector('.js-mobile-utility');
        const utilityMenu = document.querySelector('.site-header-utility-menu');

        if (mobileUtilityContainer && utilityMenu) {
            mobileUtilityContainer.innerHTML = '';
            const clone = utilityMenu.cloneNode(true);
            clone.classList.remove('site-header-utility-menu');
            clone.classList.add('site-nav-mobile-utility-menu');
            mobileUtilityContainer.appendChild(clone);
        }

        if (mobileUtilityContainer && window.cbdonnaData && window.cbdonnaData.logoutUrl) {
            const menu = mobileUtilityContainer.querySelector('.site-nav-mobile-utility-menu') || mobileUtilityContainer.querySelector('ul');
            if (menu) {
                const item = document.createElement('li');
                item.className = 'menu-item';
                const link = document.createElement('a');
                link.href = window.cbdonnaData.logoutUrl;
                link.textContent = window.cbdonnaData.logoutText;
                item.appendChild(link);
                menu.appendChild(item);
            }
        }
    }

    initMobileMenu() {
        const toggle = document.querySelector('.site-nav-toggle');
        const menuWrapper = document.querySelector('.site-nav-menu-wrapper');
        const toggleIcon = toggle ? toggle.querySelector('.site-nav-toggle-icon') : null;

        if (toggle && menuWrapper) {
            toggle.addEventListener('click', () => {
                const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
                const willOpen = !isExpanded;
                toggle.setAttribute('aria-expanded', String(willOpen));
                menuWrapper.classList.toggle('is-open');
                document.body.classList.toggle('mobile-menu-open');

                if (toggleIcon) {
                    const newSrc = willOpen
                        ? toggleIcon.getAttribute('data-src-open')
                        : toggleIcon.getAttribute('data-src-closed');
                    if (newSrc) {
                        toggleIcon.src = newSrc;
                    }
                }
            });
        }

        // Mobile sub-menu toggles
        const menuItemsWithChildren = document.querySelectorAll('.menu-item-has-children');

        menuItemsWithChildren.forEach((item) => {
            const link = item.querySelector(':scope > a');
            const subMenu = item.querySelector(':scope > .sub-menu');

            if (link && subMenu) {
                link.addEventListener('click', (event) => {
                    if (window.innerWidth > 991) {
                        return;
                    }

                    event.preventDefault();
                    item.classList.toggle('is-open');
                    subMenu.classList.toggle('is-open');
                });
            }
        });
    }

    initBackgroundImages() {
        const updateBackgroundImages = () => {
            const width = window.innerWidth;
            const divs = document.querySelectorAll('div[data-hatterkep_mobile][data-hatterkep_desktop]');

            divs.forEach((div) => {
                if (width > 991) {
                    div.style.backgroundImage = `url(${div.getAttribute('data-hatterkep_desktop')})`;
                } else {
                    div.style.backgroundImage = `url(${div.getAttribute('data-hatterkep_mobile')})`;
                }
            });
        };

        window.addEventListener('resize', updateBackgroundImages);
        updateBackgroundImages();
    }

    initLanguageDropdown() {
        const langTool = document.querySelector('.site-header-tool-lang');
        const dropdown = langTool ? langTool.querySelector('.site-header-lang-dropdown') : null;

        if (!langTool || !dropdown) {
            return;
        }

        langTool.addEventListener('click', (e) => {
            if (window.innerWidth > 991) {
                return;
            }

            if (e.target.closest('.site-header-lang-item a')) {
                return;
            }

            dropdown.classList.toggle('is-open');
        });

        document.addEventListener('click', (e) => {
            if (!dropdown.classList.contains('is-open')) {
                return;
            }
            if (!langTool.contains(e.target)) {
                dropdown.classList.remove('is-open');
            }
        });
    }

    initAutoPlayVideos() {
        const videos = document.querySelectorAll('.js-autoplay-video');
        if (videos.length === 0) return;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.play().catch(() => {});
                } else {
                    entry.target.pause();
                }
            });
        }, { threshold: 1.0 });

        videos.forEach((video) => {
            video.addEventListener('ended', () => {
                video.pause();
            });
            observer.observe(video);
        });
    }

    initMoveCouponToSidebar() {
        const move = () => {
            const sidebar = document.querySelector('.checkout-summary');
            const toggle = document.querySelector('.checkout-coupon-toggle');
            const form = document.querySelector('.checkout-coupon-form');

            if (!sidebar || !toggle || !form) return;

            sidebar.appendChild(toggle);
            sidebar.appendChild(form);
        };

        move();

        document.body.addEventListener('updated_checkout', () => {
            move();
        });
    }

    initCheckoutNotices() {
        const moveGroupToLayout = (group) => {
            const column = document.querySelector('.checkout-form-column');
            const logo = document.querySelector('.checkout-logo');
            if (!column) return;
            if (column === group.parentElement) return;
            if (logo && logo.nextSibling) {
                column.insertBefore(group, logo.nextSibling);
            } else {
                column.insertBefore(group, column.firstChild);
            }
        };

        const processNotices = () => {
            const groups = document.querySelectorAll('.woocommerce-NoticeGroup.woocommerce-NoticeGroup-checkout');
            groups.forEach(moveGroupToLayout);
        };

        const observer = new MutationObserver(() => {
            document.querySelectorAll('.woocommerce-NoticeGroup.woocommerce-NoticeGroup-checkout').forEach(moveGroupToLayout);
        });

        observer.observe(document.body, { childList: true, subtree: true });

        document.body.addEventListener('updated_checkout', () => {
            setTimeout(processNotices, 200);
        });

        document.body.addEventListener('checkout_error', () => {
            setTimeout(processNotices, 200);
        });
    }

    initMobileOrderSummary() {
        let isMobile = window.innerWidth <= 991;
        let summaryEl = null;

        const build = () => {
            summaryEl = document.querySelector('.checkout-summary');
            if (!summaryEl || summaryEl.querySelector('.checkout-summary-mobile-header')) return;

            const totalPrice = summaryEl.querySelector('.checkout-summary-total-price');
            const totalText = totalPrice ? totalPrice.textContent.trim() : '';
            const themeUri = (window.cbdonnaData && window.cbdonnaData.themeUri || '');

            const header = document.createElement('div');
            header.className = 'checkout-summary-mobile-header';
            header.setAttribute('aria-expanded', 'false');
            header.innerHTML = [
                '<span class="checkout-summary-mobile-label">Zwischensumme</span>',
                '<img class="checkout-summary-mobile-arrow" src="' + themeUri + 'assets/images/header-arrow-gold-down.svg" alt="">',
                '<span class="checkout-summary-mobile-total">' + totalText + '</span>'
            ].join('');

            const body = document.createElement('div');
            body.className = 'checkout-summary-mobile-body';

            while (summaryEl.firstChild) {
                body.appendChild(summaryEl.firstChild);
            }

            summaryEl.appendChild(header);
            summaryEl.appendChild(body);

            header.addEventListener('click', function () {
                const open = summaryEl.classList.toggle('is-open');
                this.setAttribute('aria-expanded', String(open));
            });

            setStickyTop();
        };

        const setStickyTop = () => {
            const sidebar = document.querySelector('.checkout-sidebar-column');
            const siteMain = document.querySelector('.site-main');
            if (sidebar && siteMain) {
                sidebar.style.top = siteMain.getBoundingClientRect().top + 'px';
            }
        };

        const destroy = () => {
            if (!summaryEl) return;
            const body = summaryEl.querySelector('.checkout-summary-mobile-body');
            if (!body) return;
            while (body.firstChild) {
                summaryEl.appendChild(body.firstChild);
            }
            body.remove();
            const header = summaryEl.querySelector('.checkout-summary-mobile-header');
            if (header) header.remove();
        };

        const refresh = () => {
            const nowMobile = window.innerWidth <= 991;
            if (nowMobile && !isMobile) {
                build();
            } else if (!nowMobile && isMobile) {
                destroy();
            } else if (nowMobile && isMobile) {
                setStickyTop();
            }
            isMobile = nowMobile;
        };

        if (isMobile) build();

        window.addEventListener('resize', refresh);

        document.body.addEventListener('updated_checkout', () => {
            if (window.innerWidth <= 991) {
                setTimeout(() => {
                    const summary = document.querySelector('.checkout-summary');
                    if (!summary) return;
                    const body = summary.querySelector('.checkout-summary-mobile-body');
                    const headerTotal = summary.querySelector('.checkout-summary-mobile-total');
                    if (body && headerTotal) {
                        const totalPrice = body.querySelector('.checkout-summary-total-price');
                        if (totalPrice) {
                            headerTotal.textContent = totalPrice.textContent.trim();
                        }
                    }
                    setStickyTop();
                }, 200);
            }
        });
    }
}

